import { Navbar } from "../components/Navbar.tsx";
import { HeroSection } from "../components/HeroSection.tsx";
import { FeaturesSection } from "../components/FeaturesSection.tsx";
import { EditorShowcase } from "../components/EditorShowcase.tsx";
import { UseCasesSection } from "../components/UseCasesSection.tsx";
import { CTASection } from "../components/CTASection.tsx";
import { Footer } from "../components/Footer.tsx";
import '../index.css'
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
export default function LandingPage() {
    const navigate = useNavigate()
      // const [isLoading, setIsLoading]= useState(false)
      useEffect(() => {
          if (localStorage.getItem("token") !== null && localStorage.getItem("token") !== undefined) {
              navigate('/search')
          } 
      })
  return (
    <div>
      <Navbar />
      <div>
      <main  >
        <HeroSection />
        <FeaturesSection />
        <EditorShowcase />
        <UseCasesSection />
        <CTASection />
      </main>
      <Footer />
      </div>
    </div>
  );
}
